"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Select = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Select"));
var _arrays = require("@mulesoft/exchange-ui-portals-store/lib/utils/arrays");
var _AddPillButton = _interopRequireDefault(require("../AddPillButton"));
var refUtils = _interopRequireWildcard(require("../../utils/refs"));
var _Category = _interopRequireDefault(require("./Category"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "container": "EditableCategories__container__LZHON",
  "categories-title": "EditableCategories__categories-title__4nyZ2",
  "categoriesTitle": "EditableCategories__categories-title__4nyZ2",
  "categories": "EditableCategories__categories__3KYBB",
  "select": "EditableCategories__select__1DC9b"
}; 
require('./EditableCategories.css');
var mapOptions = function mapOptions() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return categories.map(function (category) {
    return {
      label: category.displayName,
      value: category
    };
  });
};
var EditableCategories = /*#__PURE__*/function (_React$Component) {
  function EditableCategories(props) {
    var _this;
    (0, _classCallCheck2.default)(this, EditableCategories);
    _this = _callSuper(this, EditableCategories, [props]);
    (0, _defineProperty2.default)(_this, "addCategoryRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "enterCreatingState", function () {
      _this.setState({
        isCreating: true
      });
    });
    (0, _defineProperty2.default)(_this, "leaveCreatingState", function () {
      _this.setState({
        isCreating: false
      });
    });
    (0, _defineProperty2.default)(_this, "toggleSelect", function (isSelectOpen) {
      var onToggleSelect = _this.props.onToggleSelect;
      onToggleSelect(isSelectOpen);
    });
    (0, _defineProperty2.default)(_this, "deferredToggleSelect", function () {
      process.nextTick(function () {
        return _this.toggleSelect(false);
      });
    });
    (0, _defineProperty2.default)(_this, "addCategory", function (_ref) {
      var itemsSelected = _ref.itemsSelected;
      _this.setState(function (state) {
        return {
          currentCategories: state.currentCategories.concat([{
            key: itemsSelected.value.tagKey,
            displayName: itemsSelected.value.displayName,
            value: []
          }]),
          isCreating: false
        };
      });
    });
    (0, _defineProperty2.default)(_this, "handleRemoveAssetCategory", function (removedCategory) {
      var _this$props = _this.props,
        asset = _this$props.asset,
        onRemoveAssetCategory = _this$props.onRemoveAssetCategory;
      if (removedCategory.value.length > 0) {
        onRemoveAssetCategory(_objectSpread(_objectSpread({}, asset), {}, {
          category: removedCategory
        }));
      } else {
        var currentCategories = _this.state.currentCategories;
        var removedCategoryIndex = currentCategories.findIndex(function (category) {
          return category.key === removedCategory.key;
        });
        var newCategories = (0, _arrays.removeFromArray)(currentCategories, {
          index: removedCategoryIndex
        });
        _this.setState({
          currentCategories: newCategories
        });
      }
    });
    (0, _defineProperty2.default)(_this, "handleUpdateAssetCategory", function (category) {
      var _this$props2 = _this.props,
        asset = _this$props2.asset,
        onUpdateAssetCategory = _this$props2.onUpdateAssetCategory;
      onUpdateAssetCategory(_objectSpread(_objectSpread({}, asset), {}, {
        category: category
      }));
    });
    var _asset = props.asset;

    // eslint-disable-next-line react/state-in-constructor
    _this.state = {
      isCreating: false,
      currentCategories: _asset.categories || []
    };
    return _this;
  }
  (0, _inherits2.default)(EditableCategories, _React$Component);
  return (0, _createClass2.default)(EditableCategories, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var asset = this.props.asset;
      if (asset.categories !== nextProps.asset.categories) {
        this.setState({
          currentCategories: nextProps.asset.categories || []
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var currentCategories = this.state.currentCategories;
      if (prevState.currentCategories.length > currentCategories.length) {
        refUtils.focus(this.addCategoryRef);
      }
    }
  }, {
    key: "getAcceptedCategoryValues",
    value: function getAcceptedCategoryValues(assetCategory) {
      var _this$props$organizat = this.props.organizationCategories,
        organizationCategories = _this$props$organizat === void 0 ? [] : _this$props$organizat;
      var orgCategory = organizationCategories.find(function (category) {
        return category.tagKey === assetCategory.key;
      }) || {
        acceptedValues: []
      };
      return orgCategory.acceptedValues;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        _this$props3$organiza = _this$props3.organizationCategories,
        organizationCategories = _this$props3$organiza === void 0 ? [] : _this$props3$organiza,
        asset = _this$props3.asset,
        getPath = _this$props3.router.getPath;
      var _this$state = this.state,
        isCreating = _this$state.isCreating,
        currentCategories = _this$state.currentCategories;
      var applicableCategories = organizationCategories.filter(function (organizationCategory) {
        return organizationCategory.assetTypeRestrictions && (organizationCategory.assetTypeRestrictions.length === 0 || organizationCategory.assetTypeRestrictions.includes(asset.type));
      });
      var filteredCategories = applicableCategories.filter(function (organizationCategory) {
        return !currentCategories.some(function (category) {
          return category.key === organizationCategory.tagKey;
        });
      });
      if (filteredCategories.length === 0 && currentCategories.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("section", {
        "data-test-id": "asset-categories",
        "aria-labelledby": "categories-heading",
        className: styles.container
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "categories-heading",
        className: "visually-hidden"
      }, "Categories"), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.categories
      }, currentCategories.map(function (category) {
        return /*#__PURE__*/_react.default.createElement(_Category.default, {
          key: "".concat(category.key, "-").concat(category.displayName),
          category: category,
          acceptedValues: _this2.getAcceptedCategoryValues(category),
          onUpdateAssetCategory: _this2.handleUpdateAssetCategory,
          onRemoveAssetCategory: _this2.handleRemoveAssetCategory,
          onToggleCategorySelect: function onToggleCategorySelect(isOpen) {
            return _this2.toggleSelect(isOpen);
          },
          getPath: getPath
        });
      }), isCreating ? /*#__PURE__*/_react.default.createElement(_Select.default, {
        testId: "category",
        name: "category",
        placeholder: "Select a category",
        noResultsText: "No results",
        options: mapOptions(filteredCategories),
        onChange: this.addCategory,
        onBlur: this.leaveCreatingState,
        className: styles.select,
        openAfterFocus: true,
        renderInBody: false,
        autofocus: true,
        autosize: false,
        onOpen: function onOpen() {
          return _this2.toggleSelect(true);
        },
        onClose: this.deferredToggleSelect
      }) : null, !isCreating && filteredCategories.length ? /*#__PURE__*/_react.default.createElement(_AddPillButton.default, {
        "data-test-id": "add-category",
        ref: this.addCategoryRef,
        tabIndex: 0,
        onClick: this.enterCreatingState
      }, "Add category") : null));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = EditableCategories;
//# sourceMappingURL=EditableCategories.js.map